import { Navigate } from 'react-router-dom'
import AuthContainer from 'components/Auth/Container'
import AuthHeader from 'components/Auth/Header'
import Form from 'components/Auth/Form'
import { useAuthContext } from 'utils/auth'
import { cmsRoutes } from 'routes/cmsRoutes'

function SignIn() {
  const { isAuthenticated } = useAuthContext()

  if (isAuthenticated) {
    return <Navigate to={cmsRoutes.ROOT} replace />
  }

  return (
    <AuthContainer>
      <AuthHeader />

      <Form />
    </AuthContainer>
  )
}

export default SignIn
